import React from 'react';
import { NavLink } from '@teetsh/app/src/components/NavLink';
import { buttonRootStyle } from './Button';
import { BaseButtonProps } from './BaseButtonProps';
import clsx from 'clsx';
import { ButtonContent } from '@teetsh/app/src/components/Buttons/ButtonContent';

export interface Props {
  children?: React.ReactNode;
  className?: string;
  'aria-label'?: string;
  id?: string;
  to: string;
}

export function ButtonNavLink(props: Props & BaseButtonProps) {
  const {
    className,
    active,
    alignText,
    disabled,
    loading,
    extralarge,
    fill,
    intent,
    large,
    minimal,
    outlined,
    small,
    ...rest
  } = props;
  return (
    <NavLink
      css={[
        buttonRootStyle({
          active,
          alignText,
          disabled,
          extralarge,
          fill,
          hasChildren: !!props.children,
          intent,
          large,
          loading,
          minimal,
          outlined,
          small,
        }),
      ]}
      {...rest}
      className={clsx('tsh-button', className)}
    >
      <ButtonContent {...props} />
    </NavLink>
  );
}
